import { createRouter, createWebHistory } from 'vue-router';

import LoginPage from './modules/auth/LoginPage.vue';
import ProductListPage from './modules/products/product-list/ProductListPage.vue';
import { useAuth } from './modules/auth/auth';
import ProductDetailPage from './modules/products/product-detail/ProductDetailPage.vue';
import AdminUserListPage from '@/modules/admin/users/user-list/AdminUserListPage.vue';
import WebarealLogin from './modules/integrations/webareal/WebarealLogin.vue';
import WebarealCallback from './modules/integrations/webareal/WebarealCallback.vue';
import ShoptetPluginSettingsPage from './modules/integrations/shoptet/ShoptetPluginSettingsPage.vue';
import UsagePage from './modules/usage/UsagePage.vue';
import UsersPage from './modules/users/UsersPage.vue';
import ApiPage from './modules/api/ApiPage.vue';

const routes = [
  { path: '/login', component: LoginPage },
  { path: '/', component: ProductListPage, meta: { requiresAuth: true } },
  { path: '/products/:id', component: ProductDetailPage, meta: { requiresAuth: true } },
  { path: '/usage', component: UsagePage, meta: { requiresAuth: true } },
  { path: '/users', component: UsersPage, meta: { requiresAuth: true } },
  { path: '/api-settings', component: ApiPage, meta: { requiresAuth: true } },
  { path: '/admin/users', component: AdminUserListPage, meta: { requiresAuth: true } },
  { path: '/integrations/webareal/login', component: WebarealLogin, meta: { requiresAuth: true } },
  {
    path: '/integrations/webareal/callback',
    component: WebarealCallback,
    meta: { requiresAuth: true },
  },
  {
    path: '/integrations/shoptet/plugin-settings',
    component: ShoptetPluginSettingsPage,
    meta: { requiresAuth: false },
  },
  {
    path: '/integrations/shoptet/plugin-settings-dev',
    component: ShoptetPluginSettingsPage,
    meta: { requiresAuth: false },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { waitForReady, isAuthenticated } = useAuth();

  await waitForReady();

  if (to.meta.requiresAuth) {
    if (isAuthenticated.value) {
      next();
    } else {
      next('/login');
    }
  } else {
    // Non-protected route, allow access
    next();
  }
});
